(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
    const boxes = document.querySelectorAll('details.footer__block--menu');

  // Only wrap if at least two exist
  if (boxes.length >= 2) {
    const wrapper = document.createElement('div');
    wrapper.className = 'wrap-parent'; // add a class if needed

    const parent = boxes[0].parentNode;
    parent.insertBefore(wrapper, boxes[0]); // insert wrapper before the first box to wrap

    // Move the 2 elements inside the new wrapper
    wrapper.appendChild(boxes[0]);
    wrapper.appendChild(boxes[1]);
  }

  } catch(e) { console.error(e); }
})();
})();
